import(/* webpackMode: "eager", webpackExports: ["FeaturesPageContent"] */ "/vercel/path0/src/components/inbound-gpt/features-page.tsx");
